import { makeRequestPost } from "./apiHelper";

export const deleteImage = async (payload) => {

    await makeRequestPost('delete-image', payload);

}